import { useContext } from "react";
import { SharedResellerContext } from "./SharedResellerContext";

const useSharedReseller = () => useContext(SharedResellerContext);

export default useSharedReseller;
